(function () {
  var LS = 'etw_attr2', SS = 'etw_sess', GAP = 30 * 60 * 1000;
  var P = new URLSearchParams(location.search);
  var g = function (k) { return P.get(k) || ''; };
  var host = function (u) { try { return u ? new URL(u).hostname : ''; } catch (e) { return ''; } };
  var now = function () { return new Date().toISOString().slice(0, 16); };
  var since = function (t) { return String(Math.round((Date.now() - t) / 1000)); };
  var rd = function (st, k) { try { return JSON.parse(st.getItem(k)); } catch (e) { return null; } };
  var wr = function (st, k, v) { try { st.setItem(k, JSON.stringify(v)); } catch (e) {} };

  var ref = host(document.referrer);
  var external = !!ref && ref !== location.hostname;
  var ids = ['gclid', 'fbclid', 'ttclid', 'msclkid'];
  var hasParams = !!g('utm_source') || ids.some(function (k) { return !!g(k); });

  function touch() {
    var t = {
      src: g('utm_source'), med: g('utm_medium'), cmp: g('utm_campaign'),
      cnt: g('utm_content'), term: g('utm_term'), ref: external ? ref : '',
      land: location.pathname, ts: now()
    };
    ids.forEach(function (k) { t[k] = g(k); });
    return t;
  }

  // first touch — localStorage, живе назавжди
  var ft = rd(localStorage, LS) || { t: touch(), sess: 0, pv: 0 };
  // сесія — sessionStorage, нова після 30 хв паузи або нового табу
  var s = rd(sessionStorage, SS);
  if (!s || Date.now() - s.last > GAP) {
    s = { start: Date.now(), pv: 0, lt: touch(), atc: 0 };
    ft.sess = (ft.sess || 0) + 1;
  } else if (hasParams || external) {
    s.lt = touch(); // новий вхідний клік всередині сесії
  }
  s.pv++; s.last = Date.now(); ft.pv = (ft.pv || 0) + 1;
  wr(localStorage, LS, ft); wr(sessionStorage, SS, s);

  function push(extra) {
    var t = ft.t, l = s.lt, a = {
      _ft_src: t.src || t.ref || 'direct', _ft_med: t.med, _ft_cmp: t.cmp, _ft_cnt: t.cnt,
      _ft_term: t.term, _ft_ref: t.ref, _ft_land: t.land, _ft_ts: t.ts,
      _lt_src: l.src || l.ref || 'direct', _lt_med: l.med, _lt_cmp: l.cmp, _lt_cnt: l.cnt,
      _lt_term: l.term, _lt_ref: l.ref, _lt_land: l.land, _lt_ts: l.ts,
      _sess: String(ft.sess), _pv: String(ft.pv), _pv_s: String(s.pv), _sess_sec: since(s.start),
      _dev: /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
      _lang: navigator.language, _offer: window.ETW_ACTIVE_OFFER || ''
    };
    ids.forEach(function (k) { a['_' + k] = l[k] || t[k]; });
    Object.keys(extra || {}).forEach(function (k) { a[k] = extra[k]; });
    var body = { attributes: {} };
    Object.keys(a).forEach(function (k) { if (a[k]) body.attributes[k] = String(a[k]).slice(0, 250); });
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), keepalive: true
    });
  }

  // seed: записуємо атрибути в кошик ще до першого add-to-cart —
  // раз на сесію, або коли cart-cookie зник (напр. після оформленого замовлення).
  // Потрібно для checkout rule etw-cart-guard (блокує кошики без _sess до $25).
  if (!s.seed || !/(^|;\s*)cart=/.test(document.cookie)) { s.seed = 1; wr(sessionStorage, SS, s); push(); }

  // add to cart
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[name="add"], form[action*="/cart/add"] [type="submit"]')) return;
    var extra = {};
    if (!s.atc) {
      s.atc = Date.now(); wr(sessionStorage, SS, s);
      extra = { _atc_ts: now(), _atc_sec: since(s.start), _atc_pv: String(s.pv) };
    }
    setTimeout(function () { push(extra); }, 600);
  }, true);

  // checkout — затримуємо клік, поки атрибути не запишуться (макс 1.2 с)
  var coBusy = false, coNav = false;
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!el || coBusy) return;
    coBusy = true;
    e.preventDefault(); e.stopImmediatePropagation();
    var went = false;
    var go = function () {
      if (went) return;
      went = true; coNav = true; el.click();
      setTimeout(function () { coBusy = false; coNav = false; }, 1500);
    };
    push({ _co_ts: now(), _co_sec: since(s.start), _co_pv: String(s.pv), _co_from: location.pathname })
      .then(go, go);
    setTimeout(go, 1200);
  }, true);

  // вихід зі сторінки (тільки якщо щось у кошику і це не перехід у чекаут)
  window.addEventListener('pagehide', function () {
    if (s.atc && !coNav) push({ _lv_ts: now(), _lv_sec: since(s.start), _lv_pv: String(s.pv), _lv_url: location.pathname });
  });
})();